
export const PERSONAL = {
  name: 'Nitesh Shaw',
  role: 'Senior Java Developer',
  roleAlt: 'Java Developer',
  tagline: 'Building scalable backend systems with Java & Microservices',
  subTagline: '4+ years designing high-performance distributed systems that serve millions of requests at enterprise scale.',
  location: 'Bangalore, India',
  email: 'nshaw204@gmail.com',
  linkedin: 'https://linkedin.com/in/nshw',
  github: 'https://github.com/niteshshaw',
  available: true,
};


export const STATS = [
  { num: '4+', label: 'Years Experience' },
  { num: '3', label: 'Companies' },
  { num: '20%', label: 'Avg Perf Gain' },
  { num: '∞', label: 'Scalability' },
];


export const SKILLS = [
  {
    category: 'backend',
    title: 'Backend Core',
    level: 5,
    items: ['Java 17+', 'Spring Boot', 'Spring Security', 'Hibernate', 'JPA', 'REST APIs'],
  },
  {
    category: 'architecture',
    title: 'System Design',
    level: 5,
    items: ['Microservices', 'Event-Driven', 'CQRS', 'Saga Pattern', 'API Gateway', 'Circuit Breaker'],
  },
  {
    category: 'messaging',
    title: 'Streaming & Messaging',
    level: 4,
    items: ['Apache Kafka', 'Kafka Streams', 'Event Sourcing'],
  },
  {
    category: 'database',
    title: 'Data Layer',
    level: 4,
    items: ['MySQL', 'PostgreSQL', 'Redis', 'MongoDB', 'ElasticSearch'],
  },
  {
    category: 'devops',
    title: 'DevOps & CI/CD',
    level: 3,
    items: ['Docker', 'Jenkins', 'GitHub Actions', 'Maven','Gradle', 'SonarQube'],
  },
  {
    category: 'cloud & frontend',
    title: 'Cloud & Frontend',
    level: 3,
    items: ['AWS EC2/S3', 'React.js', 'Angular', 'TypeScript', 'HTML/CSS'],
  },
];


export const PROJECTS = [
  {
    num: '01',
    company: 'Genpact',
    title: "Distributed Financial Microservices Platform",

description:
  "Engineered scalable microservices architecture for an investment banking platform using Java, Spring Boot, and PostgreSQL, ensuring high availability and performance. Built and maintained RESTful APIs with comprehensive validation workflows to support complex financial operations across multiple modules. Leveraged JPA Criteria API with dynamic joins to optimize reporting queries, achieving significant performance gains. Designed an event-driven architecture using Apache Kafka to enable asynchronous communication, reduce service coupling, and improve system resilience.",

impact:
  "20% reporting performance improvement · High availability in distributed system · Reduced service coupling via Kafka-based event-driven design",
    stack: ['Java 17', 'Spring Boot', 'Kafka', 'PostgreSQL', 'Docker', 'AWS'],
    highlights: [
      'Kafka pipeline processing 2M+ events/day with zero data loss',
      '12-service microservices architecture with service mesh',
      'Circuit breakers reducing cascading failures by 90%',
    ],
  },
  {
    num: '02',
    company: 'Wenit Solutions',
    title: 'Inventory & Order Management System',
    description:
      'Built a high-performance inventory and order fulfillment backend processing 50K+ daily transactions. Implemented Saga pattern for distributed transaction management and Redis-backed caching layer for sub-10ms product catalog lookups.',
    impact: '35% reduction in order processing latency · 3× scalability gain',
    stack: ['Spring Boot', 'MySQL', 'Redis', 'Kafka', 'Jenkins', 'React'],
    highlights: [
      '50K+ daily transactions with ACID compliance',
      'Sub-10ms P99 response time for catalog reads via Redis',
      'CI/CD pipeline reducing release cycle from 2 weeks to 2 days',
    ],
  },
  {
    num: '03',
    company: 'Think and Learn',
    title: 'EdTech Learning Platform Backend',
    description:
      'Developed the backend infrastructure for a learning management system serving 100K+ concurrent students. Built real-time progress tracking with event streaming, adaptive quiz engine, and content recommendation APIs integrated with ML pipelines.',
    impact: '100K+ concurrent users supported · 28% engagement uplift',
    stack: ['Java', 'Spring MVC', 'MongoDB', 'ElasticSearch', 'AWS S3'],
    highlights: [
      'Adaptive quiz engine serving 100K+ concurrent students',
      '70% search latency reduction via ElasticSearch integration',
      'Real-time progress tracking with event streaming',
    ],
  },
];


export const EXPERIENCE = [
  {
    period: 'Jan 2023 — Present',
    role: 'Senior Java Developer',
    company: 'Genpact',
    location: 'Bangalore, India',
    type: 'Full-time',
    summary:
      'Leading backend architecture for enterprise financial services microservices platform. Owning service design, code reviews, and technical decisions for a team of 8 engineers.',
    achievements: [
      'Architected event-driven Kafka pipeline processing 2M+ events/day with zero data loss',
      'Led migration from monolith to 12-service microservices architecture, reducing deploy time by 60%',
      'Mentored 4 junior engineers on Spring Boot best practices and distributed systems design',
      'Achieved 20% throughput improvement via JVM tuning and query optimization',
      'Implemented circuit breakers and fallback strategies improving system resilience to 99.98% uptime',
    ],
  },
  {
    period: 'June 2023 — September 2024',
    role: 'Java Backend Developer',
    company: 'Wenit Solutions',
    location: 'Bangalore, India',
    type: 'Full-time',
    summary:
      'Designed and developed scalable RESTful services for e-commerce inventory management. Collaborated with frontend and DevOps teams in agile sprints.',
    achievements: [
      'Built inventory management APIs handling 50K+ daily transactions with ACID compliance',
      'Implemented Redis caching layer achieving sub-10ms P99 response for catalog reads',
      'Set up CI/CD pipelines with Jenkins and GitHub Actions, reducing release cycle from 2 weeks to 2 days',
      'Reduced DB query time by 35% through query analysis, indexing, and schema optimization',
    ],
  },
  {
    period: 'June 2021 — Feb 2023',
    role: 'Technical Support Associate',
    company: 'Think and Learn Pvt Ltd',
    location: 'Bangalore, India',
    type: 'Full-time',
    summary:
      'Contributed to backend development for the learning platform, building content delivery APIs and real-time student progress tracking systems at scale.',
    achievements: [
      'Developed REST APIs for adaptive quiz engine serving 100K+ concurrent students',
      'Integrated ElasticSearch for full-text content search reducing search latency by 70%',
      'Built real-time progress tracking using event streaming and MongoDB aggregations',
      'Participated in on-call rotation and improved MTTR by establishing observability dashboards',
    ],
  },
];
